import {ChatMessage, DataObjectId, SystemMessageUtils} from 'yougile-model'

export const getCountMentions = (
  messages: Map<number, ChatMessage>,
  userId: DataObjectId,
  since = 0
): number => {
  if (!messages) {
    return 0
  }

  let count = 0

  messages.forEach(m => {
    if (messageHasMention(m, userId, since)) {
      count++
    }
  })

  return count
}

const messageHasMention = (
  message: ChatMessage,
  userId: DataObjectId,
  since: number
): boolean => {
  if (SystemMessageUtils.isSystemMessage(message)) {
    return false
  }

  if (message.deleted) {
    return false
  }

  if (since >= message.timestamp) {
    return false
  }

  const params = message?.properties?.params as any
  return params?.chunks?.some(
    (chunk: any) => chunk.type === 'user' && chunk.data?.userId === userId
  )
}

export const getNearestMention = (
  messages: Map<number, ChatMessage>,
  userId: DataObjectId,
  since = 0
): ChatMessage | undefined => {
  if (!messages) {
    return undefined
  }

  for (const message of messages.values()) {
    if (messageHasMention(message, userId, since)) {
      return message
    }
  }

  return undefined
}
